"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ButtonDefault: function() {
        return ButtonDefault;
    },
    LinkButtonDefault: function() {
        return LinkButtonDefault;
    },
    LinkButtonCustom: function() {
        return LinkButtonCustom;
    },
    ButtonPrimary: function() {
        return ButtonPrimary;
    },
    ButtonCustomPrimary: function() {
        return ButtonCustomPrimary;
    },
    ButtonSecondary: function() {
        return ButtonSecondary;
    },
    ButtonDefaultRed: function() {
        return ButtonDefaultRed;
    },
    ButtonHighlight: function() {
        return ButtonHighlight;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var ButtonDefault = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, className = props.className, _props_type = props.type, type = _props_type === void 0 ? "button" : _props_type, darkMode = props.darkMode;
    return /*#__PURE__*/ _react.createElement("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)(className, "border-solid inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm", "font-medium rounded-md text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 ", "focus:ring-accent-500 focus:bg-gray-50", darkMode ? {
            "focus:ring-offset-gray-900 focus:ring-highlight-400": true
        } : {
            "focus:ring-offset-gray-100": true
        }, {
            "hover:bg-gray-50": !disabled,
            "opacity-50 hover:bg-white cursor-default": disabled
        }),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var LinkButtonDefault = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, className = props.className, href = props.href, target = props.target;
    var onLinkClick = function(e) {
        if (disabled) {
            e.preventDefault();
            return;
        }
        onClick && onClick(e);
    };
    return /*#__PURE__*/ _react.createElement("a", {
        href: href,
        target: target,
        onClick: onLinkClick,
        className: (0, _classnames.default)(className, "cursor-pointer border-solid inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm", "font-medium rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 ", "focus:ring-offset-gray-100 focus:ring-accent-500 focus:bg-gray-50", {
            "hover:bg-gray-50": !disabled,
            "opacity-50 hover:bg-white cursor-default": disabled
        }),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var LinkButtonCustom = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, className = props.className, href = props.href, target = props.target;
    var onLinkClick = function(e) {
        if (disabled) {
            e.preventDefault();
            return;
        }
        onClick && onClick(e);
    };
    return /*#__PURE__*/ _react.createElement("a", {
        href: href,
        target: target,
        onClick: onLinkClick,
        className: (0, _classnames.default)("cursor-pointer inline-flex items-center justify-center px-4 py-2 text-sm border border-transparent", "font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ", _defineProperty({
            "opacity-50 cursor-default": disabled
        }, className, className)),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var ButtonPrimary = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var id = props.id, disabled = props.disabled, onClick = props.onClick, children = props.children, _props_type = props.type, type = _props_type === void 0 ? "submit" : _props_type, color = props.color, _props_className = props.className, className = _props_className === void 0 ? null : _props_className, _props_darkMode = props.darkMode, darkMode = _props_darkMode === void 0 ? false : _props_darkMode;
    return /*#__PURE__*/ _react.createElement("button", {
        id: id,
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)("inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 ", className, darkMode ? {
            "text-gray-700": true,
            "bg-white focus:ring-highlight-400 focus:ring-offset-gray-900": color !== "red",
            "hover:bg-gray-50": color !== "red" && !disabled,
            "opacity-50 hover:bg-white cursor-default": disabled
        } : {
            "text-white": true,
            "bg-accent-600 focus:ring-accent-500": color !== "red",
            "hover:bg-accent-700": color !== "red" && !disabled,
            "opacity-50 cursor-default": disabled
        }, {
            "bg-red-600 focus:ring-red-500": color === "red",
            "hover:bg-red-500": color === "red" && !disabled
        }),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var ButtonCustomPrimary = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, onClick = props.onClick, children = props.children, _props_type = props.type, type = _props_type === void 0 ? "submit" : _props_type, _props_className = props.className, className = _props_className === void 0 ? null : _props_className;
    return /*#__PURE__*/ _react.createElement("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)("inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2", _defineProperty({
            "opacity-50 cursor-default": disabled
        }, className, className)),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var ButtonSecondary = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, color = props.color, _props_type = props.type, type = _props_type === void 0 ? "submit" : _props_type, _props_className = props.className, className = _props_className === void 0 ? null : _props_className, _props_darkMode = props.darkMode, darkMode = _props_darkMode === void 0 ? false : _props_darkMode;
    return /*#__PURE__*/ _react.createElement("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)("inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ", className, darkMode ? {
            "text-white bg-gray-900 focus:ring-highlight-400 border-white focus:ring-offset-gray-900": color !== "red",
            "hover:bg-gray-800": color !== "red" && !disabled
        } : {
            "text-accent-600 bg-white border-accent-600 focus:ring-accent-500": color !== "red",
            "hover:bg-accent-50": color !== "red" && !disabled
        }, {
            "text-red-700 bg-red-100 focus:ring-red-500": color === "red",
            "hover:bg-red-200": color === "red" && !disabled,
            "opacity-50 cursor-default": disabled
        }),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var ButtonDefaultRed = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, _props_type = props.type, type = _props_type === void 0 ? "submit" : _props_type, _props_className = props.className, className = _props_className === void 0 ? null : _props_className;
    return /*#__PURE__*/ _react.createElement("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)("inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ", "text-red-700 border-red-500 focus:ring-red-500", className, {
            "hover:bg-red-200": !disabled,
            "opacity-50 cursor-default": disabled
        }),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});
var ButtonHighlight = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled, onClick = props.onClick, children = props.children, _props_type = props.type, type = _props_type === void 0 ? "submit" : _props_type, _props_className = props.className, className = _props_className === void 0 ? null : _props_className;
    return /*#__PURE__*/ _react.createElement("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: (0, _classnames.default)("inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm", "text-gray-900 font-medium  bg-highlight-400 hover:bg-highlight-500 ", "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-highlight-400 focus:ring-offset-gray-700 ", {
            "opacity-50 cursor-default": disabled
        }, className),
        "data-testid": props["data-testid"],
        ref: ref
    }, children);
});

//# sourceMappingURL=Button.js.map